import { AffirmMessageElement, Elements } from '@stripe/react-stripe-js';
import { StripeAffirmMessageElementOptions } from '@stripe/stripe-js';
import { StripeContext } from '../../../context/stripe-context';
import { useContext, useEffect, useState } from 'react';
import { useCustomerAPI } from '../../../clients/customer-api/customer-api-client';
import { Location } from '../../../clients/quipli-service/location/location';

export const PayLaterPlanMessaging = ({ locationId, amount }: { locationId: number; amount: number }) => {
  const { getLocationById } = useCustomerAPI();
  const stripe = useContext(StripeContext);

  const [location, setLocation] = useState<Location>();

  useEffect(() => {
    const refreshLocation = async () => setLocation(await getLocationById(locationId));
    refreshLocation();
  }, []);

  return (
    <div>
      {!!location && (
        <Elements stripe={stripe}>
          <AffirmMessageElement
            options={{
              amount,
              currency: location.currency as StripeAffirmMessageElementOptions['currency'],
              fontSize: '16px',
              fontColor: '#475467',
            }}
          />
        </Elements>
      )}
    </div>
  );
};
